import { action, computed, makeObservable, observable } from 'mobx';

import InvoiceDetailsStore from './InvoiceDetailsStore';
import InvoiceFileStore from './InvoiceFileStore';
import { ITranslateStore } from './TranslateStore';
import { IMandatesStore } from './MandatesStore';

export type InvoiceDetailsModalTab = 'tab-invoice-lines' | 'tab-invoice-files' | 'tab-invoice-details';

const DEFAULT_SELECTED_TAB: InvoiceDetailsModalTab = 'tab-invoice-lines';

export default class InvoiceDetailsTabsStore {
  @observable
  public currentTab: InvoiceDetailsModalTab = DEFAULT_SELECTED_TAB;

  constructor(
    private invoiceFileStore: InvoiceFileStore,
    private invoiceDetailsStore: InvoiceDetailsStore,
    private translateStore: ITranslateStore,
    private mandatesStore: IMandatesStore
  ) {
    makeObservable(this);
  }

  @action
  public setCurrentTab(currentTab: InvoiceDetailsModalTab): void {
    this.currentTab = currentTab;
  }

  @action
  public resetCurrentTabToDefault(): void {
    this.currentTab = DEFAULT_SELECTED_TAB;
  }

  @computed
  public get invoiceFilesTabTitle(): string {
    const filesTabTitle = this.translateStore.translate('shared.invoice-details-modal.tab-titles.invoice-files');
    const sortedInvoiceFileTypes = this.invoiceFileStore.sortedInvoiceFileTypes;

    return `${filesTabTitle}${this.hasInvoiceFiles ? ` (${sortedInvoiceFileTypes.length})` : ''}`;
  }

  @computed
  public get showFilesTab(): boolean {
    return this.hasInvoiceFiles || this.invoiceFileStore.fileTypes.isFinishedWithError;
  }

  @computed
  public get showDetailsTab(): boolean {
    return this.invoiceDetailsStore.invoiceDetailsRequest.source === 'BILL';
  }

  @computed
  public get showInterestsDetailsTab(): boolean {
    const standingTotalAmount = this.invoiceDetailsStore.invoiceDetails.payload?.details?.unsettledInterests?.standingTotalAmount;
    const mandate = this.mandatesStore.mandate;

    return !!standingTotalAmount && standingTotalAmount !== 0 && mandate.isFinished && mandate.payload.billingMandateLevel === 'FULL';
  }

  @computed
  private get hasInvoiceFiles(): boolean {
    const invoiceFileTypes = this.invoiceFileStore.fileTypes.payload;
    const sortedInvoiceFileTypes = this.invoiceFileStore.sortedInvoiceFileTypes;

    return invoiceFileTypes && sortedInvoiceFileTypes.length !== 0;
  }
}
